import { useEffect, useState } from 'react';

export const useLocation = () => {
  const [location, setLocation] = useState(typeof window === 'undefined' ? ({} as Location) : window.location);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handlePopstate = () => {
      setLocation(window.location);
    };

    window.addEventListener('popstate', handlePopstate);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  return location;
};
